import { Box, Flex, Grid, GridItem, Image, Input,  Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './reference.style';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { AlertCard, CustomButton, CustomToast, ActionEditIcon, CustomTable } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IReference } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from '../../../../components/CustomTable/customTable';

const Header = [
    { id: 1, head: 'S. No' },
    { id: 2, head: 'Reference' },
    { id: 4, head: 'Status' },
    { id: 5, head: 'Actions' },
];

const Reference = () => {
    const [references, setReferences] = useState<IReference[]>([]);
    const [AlertOpen, setAlertOpen] = useState(false);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentReference, setCurrentReference] = useState({id: 0,reference: '',status: true});
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [statusChangeSource, setStatusChangeSource] = useState<'table' | 'drawer' | null>(null);

      useEffect(() => {
        loadReference();
      }, []);
    
      const loadReference = async () => {
          const response = await fetchApi<IReference[]>("Hrlense_Reference", "GET");
          if (response) setReferences(response);
      };
 
    const handleStatusChange = (id: number, newStatus: boolean) => {
        setSelectedId(id);
        setPendingStatus(newStatus);
        setStatusChangeSource('table');
        setAlertOpen(true);
    };
 
    const handleDrawerStatusChange = (newStatus: boolean) => {
        setPendingStatus(newStatus);
        setStatusChangeSource('drawer');
        setAlertOpen(true);
    };
 
    const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const referenceId = statusChangeSource === "table" ? selectedId : currentReference.id;

        const response = await fetchApi( `Hrlense_Reference/toggleStatus/${referenceId}`,"PUT", { id: referenceId, status: pendingStatus });
        if (response) {
          if (statusChangeSource === "table") {
            setReferences((prev) => prev.map((references) => references.id === selectedId ? { ...references, status: pendingStatus } : references));
          } else {
            setCurrentReference((prev) => ({ ...prev, status: pendingStatus }));
          }
        }
    }
    setAlertOpen(false);
  };
 
    const handleAddNewReference = () => {
        setIsEditMode(false);
        setCurrentReference({ id: 0, reference: '', status: true});
        setDrawerOpen(true);
    };

    const handleEditReference = (reference: IReference) => {
        setIsEditMode(true);
        setSelectedId(reference.id);
        setCurrentReference(reference);
        setDrawerOpen(true);
    };
 
    const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    setCurrentReference(prev => ({
      ...prev,
      [name]: value
    }));
  };


    const handleSubmit = async () => {
        if (!currentReference.reference.trim()) {
    addToast({ message: "Please enter Reference Name", status: "warning" });
    return;
  }
        if (isEditMode) {
          const response = await fetchApi( `Hrlense_Reference/${currentReference.id}`, 'PUT',{ id: currentReference.id, reference: currentReference.reference, status: currentReference.status}, null, "Reference updated successfully");
            if (response) setReferences((prev) => prev.map((industryType) => (industryType.id === selectedId ? currentReference : industryType)));
          } else {
            const response = await fetchApi<IReference>( 'Hrlense_Reference', 'POST', { reference: currentReference.reference, status: currentReference.status}, null, "Reference added successfully");
    
            if (response) setReferences((prev) => [...prev, response]);
          }
          setDrawerOpen(false);
        };
    
    const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

    return (
        <MyDiv>
          <Box position="relative" minH="300px">
            {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>) : (
            <>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Reference</Text>
                <Flex gap={2}>
                    <CustomButton title="Add New Reference" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewReference} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <CustomTable value={references} >
                      <Column header="S. No" body={(_, index) => index + 1} />
                      <Column header="Reference" field="reference" />
                      <Column
                        header="Status"
                        body={(row: any) => (
                          <Select
                            value={row.status ? "true" : "false"}
                            onChange={(e) => handleStatusChange(row.id, e.target.value === "true")}
                            width="120px"
                            height="32px"
                            icon={<ChevronDownIcon />}
                            borderRadius="4px"
                            color={getStatusColor(row.status)}
                            className="font-poppins text_medium text_xsm"
                          >
                            <option value="true" style={{ color: "#38A169" }}>Active</option>
                            <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                          </Select>
                        )}
                      />
                    
                      <Column
                        header="Actions"
                        body={(row: any) => ( <ActionEditIcon onClick={() => handleEditReference(row)} />
                        )}
                      />
                    </CustomTable>

                </GridItem>
            </Grid>
            <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Reference' : 'Add New Reference'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Box py={4}>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Reference</FormLabel>
                                <Input name="reference" value={currentReference.reference} onChange={handleInputChange} placeholder="Enter Reference Name" />
                            </FormControl>
                            <FormControl mb={4}>
                                <FormLabel>Status</FormLabel>
                                <Select w="120px" value={currentReference.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentReference.status)}>
                                    <option value="true" style={{ color: "#38A169" }}> Active</option>
                                    <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                                </Select>
                            </FormControl>
                        </Box>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                            <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Reference" : "Add Reference"}</Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
            </>)}
            </Box>
        </MyDiv>
    )
}

export default Reference;